import { makeStyles } from 'tss-react/mui';
import { spacing } from '../../styles/jss/variables';
import { getBadgeTextFontSize, getBadgeTextSpacingOverride } from '../../styles/jss/badgeTextTypography';
const useStyles = makeStyles()((theme, params, classes) => {
    return {
        container: {
            position: 'absolute',
            display: 'flex',
            flexDirection: 'column',
            // alignItems is set solely by the topLeft/topRight/bottomLeft/bottomRight position
            justifyContent: 'flex-start',
            overflow: 'hidden',
            margin: 0,
            cursor: 'auto',
            // Keep the badge from growing past the product image it overlays
            maxWidth: '100%',
            boxSizing: 'border-box',
        },
        topLeft: {
            top: 0,
            left: 0,
            right: 'auto',
            bottom: 'auto',
            alignItems: 'flex-start',
            paddingTop: spacing.xs,
        },
        topRight: {
            top: 0,
            right: 0,
            left: 'auto',
            bottom: 'auto',
            alignItems: 'flex-end',
            paddingTop: spacing.xs,
        },
        bottomLeft: {
            bottom: 0,
            left: 0,
            top: 'auto',
            right: 'auto',
            alignItems: 'flex-start',
            paddingBottom: spacing.xs,
        },
        bottomRight: {
            bottom: 0,
            right: 0,
            top: 'auto',
            left: 'auto',
            alignItems: 'flex-end',
            paddingBottom: spacing.xs,
        },
        carouselPaddingLeft: {
            paddingLeft: spacing.xs,
        },
        carouselPaddingRight: {
            paddingRight: spacing.xs,
        },
        badgeContent: {
            display: 'flex',
            flexDirection: 'column',
            // Set directly from the badge's own position (not inherited) so this can never be
            // affected by the container's align-items resolution order
            alignItems: params.isLeftAligned ? 'flex-start' : 'flex-end',
            alignSelf: params.isLeftAligned ? 'flex-start' : 'flex-end',
            gap: 0,
        },
        textLine: {
            padding: `0 ${spacing.xs}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            maxWidth: '100%',
            boxSizing: 'border-box',
        },
        textLine1: {
            backgroundColor: params.line1BackgroundColor,
            color: params.line1TextColor,
        },
        textLine2: {
            backgroundColor: params.line2BackgroundColor,
            color: params.line2TextColor,
        },
        textLineContent: Object.assign(Object.assign(Object.assign(Object.assign({}, theme.typography.xxs_bold), { fontSize: getBadgeTextFontSize(params, 'base') }), getBadgeTextSpacingOverride(params, 'base')), { color: 'inherit', textAlign: 'center', 
            // pre-line preserves user-entered line breaks while still wrapping long lines
            whiteSpace: 'pre-line', wordBreak: 'break-word', overflow: 'hidden', display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 3, textOverflow: 'ellipsis', [theme.breakpoints.up('sm')]: Object.assign(Object.assign(Object.assign({}, theme.typography.small_bold), { fontSize: getBadgeTextFontSize(params, 'sm') }), getBadgeTextSpacingOverride(params, 'sm')), [theme.breakpoints.up('md')]: Object.assign(Object.assign(Object.assign({}, theme.typography.xxs_bold), { fontSize: getBadgeTextFontSize(params, 'md') }), getBadgeTextSpacingOverride(params, 'md')), [theme.breakpoints.up('lg')]: Object.assign(Object.assign(Object.assign({}, theme.typography.small_bold), { fontSize: getBadgeTextFontSize(params, 'lg') }), getBadgeTextSpacingOverride(params, 'lg')), [theme.breakpoints.up('xl')]: Object.assign({ fontSize: getBadgeTextFontSize(params, 'xl') }, getBadgeTextSpacingOverride(params, 'xl')) }),
    };
});
export default useStyles;
